import React    from "react";
import { 
  WebIcon,
  MobileIcon,
  SearchResult
}               from "./index";

const Section = () => {
  return (
    <div className="section-wrapper">
      <MobileIcon />
      <div className="section-wrapper-middle">
        <h1>Aradigini kolaylikla bul !</h1>
        <p>Hadi hemen arat ve bul bla bla</p>
        <div className="search-container">
          <div className="search-box">
            <input
              type="text"
              className="search-input"
              placeholder="Search.."
            />
            <SearchResult />
            <button className="search-button">
              <i className="fas fa-search" />
            </button>
          </div>
        </div>
      </div>
      <WebIcon />
    </div>
  );
};

export default Section;
